<template>
    <div v-show="store.state.currentTab === 'Help'" class="menu-content" id="help-settings">

        <h1 class="themed-title">{{t('help title','Beadographer Help')}}</h1>
        <p>{{t('help intro','These resources will help you get started using Beadographer. We hope you enjoy using this app!')}}</p>
        <h2>{{t('learn to use beadographer title','Learn to use Beadographer')}}</h2>
        <ul>
            <li><a href="https://www.youtube.com/@beadographer" target="_blank">{{t('learning option 1','Watch our Youtube tutorials')}}</a>.</li>
            <li><a href="https://www.facebook.com/groups/beadographer" target="_blank">{{t('learning option 3','Join the Beadographer Facebook Group and find out what people are making.')}}</a></li>
        </ul>
        <div id="membership-info" v-if="!store.state.loggedIn">
            <h2>{{t('become a member title','Become a member')}}</h2>
            <p>{{t('join beadographer intro','Joining Beadographer as a member gives you access to the membership version. This lets you:')}}</p>
            <ul>
                <li>{{t('membership benefit 1','Load and save your projects.')}}</li>
                <li>{{t('membership benefit 2','Change the size, library, and pattern of your projects.')}}</li>
                <li>{{t('membership benefit 3','Load and save your palettes.')}}</li>
                <li>{{t('membership benefit 4','Share your projects with other people.')}}</li>
                <li>{{t('membership benefit 5','Export your projects to PDF.')}}</li>
            </ul>
            <p>{{t('membership price info','Membership costs $14.99 / year.')}}</p>
            <a class="button" id="sign-up-button" href="https://beadographer.com/membership-account/membership-checkout/?level=4" target="_blank">{{t('sign up button','Sign up now')}}</a>
        </div>
        <h2>{{t('having problems title','Having problems?')}}</h2>
        <p>{{t('get in touch info','Get in touch with us with the contact form. We’ll be in touch with you as soon as we can!')}}</p>
        <a class="button" href="https://beadographer.com/contact" target="_blank">{{t('get in touch button','Get in touch')}}</a>
        <h2>{{t('about beadographer title','About Beadographer')}}</h2>
        <p>{{t('about beadographer info','Visit our website to learn more about the app, the developers, and future releases of the app.')}}</p>
        <a class="button" href="https://beadographer.com/about" target="_blank">{{t('visit our website button','Visit our website')}}</a>
    </div>
</template>

<script>

export default {
}
</script>
